export default class {
  constructor() {
    return new window.R.ui.Post("recognition", { page: this.getPage() });
  }

  getPage() {
    return 'base-page';
  }
}
